<div class="form-group d-flex align-items-center">
    <ng-content select="[kui-side-panel-label]"></ng-content>
    <ng-content select="[kui-side-panel-span]"></ng-content>
    <ng-content></ng-content>
</div>
